import './FunnelChart.css';

const renderFunnel = (brand, index,settings,getLogoComponent,labelWidth,maxBarWidth,barHeight) => {
    const shlbl=index%settings.columns===0?true:false;
    const funnelDataWithConversion = brand.funnelData.map((stage, idx) => {
      const prevPercentage = idx === 0 ? 100 : brand.funnelData[idx - 1].percentage;
      const conversion = prevPercentage > 0 ? ((stage.percentage / prevPercentage) * 100).toFixed(1) : 0;
      return { ...stage, conversion };
    });

    return (
      <div key={index} className="funnel-item">
        <div className="brand-header">
          {getLogoComponent(brand.logo)}
          <h3 style={{ color: brand.color }}>
            {brand.name}
          </h3>
        </div>
        
        <div className="funnel-content">
          {/* Labels */}
          {shlbl && settings.showLabels && (
            <div className="funnel-labels">
              {funnelDataWithConversion.map((stage, idx) => (
                <div key={idx} className="funnel-label">
                  {stage.label}
                </div>
              ))}
            </div>
          )}
          
          {/* Bars */}
          <div 
            className="funnel-bars" 
            style={{ marginLeft: settings.showLabels ? '0' : `${labelWidth}px` }}
          >
            {funnelDataWithConversion.map((stage, idx) => (
              <div key={idx} className="bar-container">
                <div
                  className={`funnel-bar ${settings.animation ? 'animated' : ''}`}
                  style={{
                    width: `${(stage.percentage / 100) * maxBarWidth}px`,
                    height: barHeight,
                    backgroundColor: brand.color,
                    opacity: idx === 0 ? 1 : 0.85 - (idx * 0.1)
                  }}
                  data-tooltip={`
                    ${stage.label}: ${stage.percentage.toFixed(2)}%
                    ${idx > 0 ? `| Conversion: ${stage.conversion}%` : ''}
                    ${settings.showFrequency ? `| Frequency: ${Math.round(stage.percentage * 2.5)}` : ''}
                    ${settings.showBase && idx === funnelDataWithConversion.length - 1 ? `| Base: Awareness` : ''}
                  `}
                >
                  <span className="percentage-text">
                    {stage.percentage.toFixed(2)}
                    {settings.showPercentSymbol && '%'}
                  </span>
                </div>
                
                {/* Conversion indicator */}
                {idx > 0 && (
                  <div className="conversion-indicator">
                    <span className="conversion-text">↰ {stage.conversion}%</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  export default renderFunnel